import { AxiosInstance, CancelToken } from 'axios';
import { createContextAwareHandlers } from './instance';

interface PercapitaOffset {
  distanceKm: number;
  distanceMiles: number;
  kilosCo2: number;
  kilosCo2e: number;
  lbsCo2: number;
  lbsCo2e: number;
  source: string;
}

interface BatchResponseOk {
  priceQuote: SubscriptionObject;
  attachment: {
    storageBlobName: string;
    type: number;
  };
  attachmentTempUrl: string;
  rows: number;
}

interface BatchResponseError {
  message: string;
  data: string[];
}

export const getCarFootprint = (instance: AxiosInstance) => async (countryCode: string, cars: number): Promise<PercapitaOffset> => {
  const { data } = await instance.get<PercapitaOffset>(`/footprint/cars`, {
    params: {
      cars,
      area: countryCode ?? 'EU',
      km: 'monthly',
    },
  });

  return data;
};

export const processCarBatch = (instance: AxiosInstance) => async (
  customerId: string,
  file: unknown,
  sourceToken: CancelToken,
): Promise<BatchResponseOk & BatchResponseError> => {
  const { data } = await instance.post<BatchResponseOk & BatchResponseError>(`/customers/${customerId}/attachments/processcarbatch`, file, {
    headers: {
      'Content-Type': 'image/jpeg',
    },
    cancelToken: sourceToken,
  });

  return data;
};

export const downloadOrderAttachment = (instance: AxiosInstance) => async (
  customerId: string,
  subscriptionId: string,
  fileName: string,
): Promise<Blob> => {
  const { data } = await instance.get<Blob>(`/customers/${customerId}/subscriptions/${subscriptionId}/attachments/${fileName}/download`, {
    responseType: 'blob',
  });
  return data;
};

const handlers = {
  getCarFootprint,
  processCarBatch,
  downloadOrderAttachment,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createCarLoansApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createCarLoansApi;
